export const validateBoolean = (value) => value === true || value === false;